import { get } from './index';

/**
 * Get a shared recipe by its share token
 * This is a public endpoint that doesn't require authentication
 */
export const getSharedRecipe = (token) => {
  return get(`public/recipe/share/${token}`);
};

/**
 * Get all units of measure for unit conversion
 * This is a public endpoint that doesn't require authentication
 */
export const getUnitsOfMeasure = () => {
  return get('public/recipe/units-of-measure');
};
